import http, { AUTH_ROUTES } from "../../../../services/api";
import {
  errorNotifier,
  successNotifier,
} from "../../../../components/NotificationHandler";
import { DATA_ROWS } from "../../../../components/CustomTable";

// export const getResidents = async (setLoading, setResidentRows) => {
//   try {
//     const {
//       data: {
//         result: { data },
//       },
//     } = await http.get(AUTH_ROUTES.GET_RESIDENT);
//     setLoading(false);
//     setResidentRows(data.tenants);
//     console.log(data, "findResidents");
//   } catch (e) {
//     setLoading(false);
//     setResidentRows([]);
//     // errorNotifier(e.response?.data?.result?.message);
//   } finally {
//     setLoading(false);
//   }
// };
export const getResidents = async (
  userId,
  setLoading,
  setResidentRows,
  skip = 0,
  limit = DATA_ROWS.LIMIT
) => {
  const page = skip * limit;
  try {
    const {
      data: {
        result: { data },
      },
    } = await http.get(AUTH_ROUTES.GET_RESIDENT({ userId, page, limit }));
    setLoading(false);
    setResidentRows(data.tenants);
  } catch (e) {
    setLoading(false);
    setResidentRows([]);
    // errorNotifier(e.response?.data?.result?.message);
  } finally {
    setLoading(false);
  }
};

export const getAllResidents = async (
  userId,
  setLoading,
  setAllResidentRows,
  skip = 0,
  setTotal,
  filter = {}
) => {
  const page = skip * DATA_ROWS.LIMIT;
  try {
    const {
      data: {
        result: { data },
      },
    } = await http.get(AUTH_ROUTES.GET_ALL_RESIDENT({ userId, page, filter }));
    setLoading(false);
    setAllResidentRows(data?.tenants);
    setTotal && setTotal(data?.totalTenants);
  } catch (e) {
    setLoading(false);
    setAllResidentRows([]);
  } finally {
    setLoading(false);
  }
};

export const updateResident = async (payload,residentId, setLoading, onClose) => {
  try {
    await http.put(
      AUTH_ROUTES.UPDATE_RESIDENT(residentId),
      payload
    );
    setLoading(false);
    successNotifier("Successfully updated a resident");
  } catch (e) {
    errorNotifier(e.response?.data?.result?.message);
    setLoading(false);
  } finally {
    setLoading(false);
    onClose();
  }
};

export const createResident = async (
  payload,
  setLoading,
  setRefresh,
  onClose
) => {
  try {
    await http.post(AUTH_ROUTES.CREATE_RESIDENT, payload);
    setLoading(false);
    successNotifier("Successfully created a resident");
    setRefresh(true);
    onClose();
  } catch (e) {
    setLoading(false);
    errorNotifier(
      e?.response?.data?.errors?.[0]?.msg || e?.response?.data?.result?.message
    );
  }
};

export const updateResidentStatus = (residentId, payload) => {
  return http.put(`/manager/tenants/${residentId}`, payload);
};

// export const createResident = async (
//   payload,
//   setLoading,
//   setRefresh,
//   onClose
// ) => {
//   try {
//     await http.post(AUTH_ROUTES.CREATE_RESIDENT, payload);
//     setLoading(false);
//     successNotifier("Successfully created a resident");
//     setRefresh(true);
//     onClose();
//   } catch (e) {
//     setLoading(false);
//     onClose();
//     if (e?.response) {
//       errorNotifier(
//         e?.response?.data?.errors?.[0]?.msg ||
//           e?.response?.data?.result?.message
//       );
//     } else {
//       errorNotifier("Please check your network connection");
//     }

//     throw new Error();
//   } finally {
//     setLoading(false);
//     setRefresh(false);
//   }
// };

export const banResident = async (payload) => {
  try {
    await http.put(
      AUTH_ROUTES.UPDATE_RESIDENT(payload.userId, payload._id),
      payload
    );
    successNotifier("Successfully banned resident");
  } catch (e) {
    errorNotifier(e?.response?.data?.errors[0]?.msg);
  }
};

export const deleteResident = async (payload, onRefresh) => {
  try {
    await http.delete(AUTH_ROUTES.DELETE_RESIDENT(payload._id));
    successNotifier("Successfully deleted resident");
    onRefresh();
  } catch (e) {
    // errorNotifier(e?.response?.data?.errors[0]?.msg);
  }
};

// export const getHouseMember = async (
//   userId,
//   setLoading,
//   setAllResidentRows
// ) => {
//   try {
//     const {
//       data: {
//         result: { data },
//       },
//     } = await http.get(AUTH_ROUTES.GET_MEMBERS({ userId }));
//     setLoading(false);
//     setAllResidentRows(data?.tenants);
//   } catch (e) {
//     setLoading(false);
//     setAllResidentRows([]);
//     // errorNotifier(e.response?.data?.result?.message);
//   } finally {
//     setLoading(false);
//   }
// };

export const getHouseMember = async (id, setMember, setRefresh, setLoading) => {
  try {
    const res = await http.get(AUTH_ROUTES.GET_HOUSE_MEMBERS({ id }));
    setMember(res.data.result.data);
    setRefresh((prev) => !prev);
    setLoading(false);
  } catch (err) {
    console.log(err);
    setRefresh(false);
  } finally {
    setLoading(false);
  }
};
export const createHouseMember = async (
  payload,
  onClose,
  setRefresh,
  setLoading
) => {
  try {
    await http.post(AUTH_ROUTES.CREATE_MEMBERS, payload);
    successNotifier("Successfully created a Family Member");
    setRefresh((prev) => !prev);
    setLoading(false);
    onClose();
  } catch (e) {
    console.log("ERROR", e);
    // errorNotifier(e.response?.data?.result?.message);
    onClose();
  }
};
export const createHouseHelp = async (
  payload,
  onClose,
  setRefresh,
  setLoading
) => {
  try {
    await http.post(AUTH_ROUTES.CREATE_MEMBERS, payload);
    successNotifier("Successfully created a House Help");
    setRefresh((prev) => !prev);
    setLoading(false);
    onClose();
  } catch (e) {
    console.log("ERROR", e);
    // errorNotifier(e.response?.data?.result?.message);
    onClose();
  }
};
export const editHouseMaid = async (
  payload,
  onClose,
  setRefresh,
  setLoading
) => {
  try {
    await http.put(AUTH_ROUTES.EDIT_MEMBERS(payload?.userId), payload);
    setLoading(false);
    onClose();
    successNotifier("Successfully Updated HouseHelp");
    setRefresh(true);
  } catch (e) {
    console.log("ERROR", e);
    errorNotifier(e.response?.data?.result?.message);
  } finally {
    setRefresh(false);
    setLoading(false);
  }
};

export const editHouseMember = async (
  payload,
  onClose,
  setRefresh,
  setLoading
) => {
  try {
    await http.put(AUTH_ROUTES.EDIT_MEMBERS(payload?.userId), payload);
    setLoading(false);
    onClose();
    successNotifier("Successfully Updated Family Member");
    setRefresh(true);
  } catch (e) {
    console.log("ERROR", e);
    errorNotifier(e.response?.data?.result?.message);
  } finally {
    setLoading(false);
    setRefresh(false);
  }
};

export const getTenants = async (userId, setLoading, setTenants) => {
  try {
    const {
      data: {
        result: { data },
      },
    } = await http.get(AUTH_ROUTES.GET_TENANTS({ userId }));
    setLoading(false);
    setTenants(data?.tenants);
  } catch (e) {
    console.log(e);
  } finally {
    setLoading(false);
  }
};


// Modified fetchStreetsData function
export const fetchStreetsData = async (setStreetsData, setLoadingStreets) => {
  try {
    setLoadingStreets(true);
    const { data } = await http.get("/user/house");

    const transformedData = data?.result?.data?.houses?.reduce((acc, house) => {
      const streetId = house?.streetId?._id;
      const streetName = house?.streetId?.streetName;
      const houseId = house?._id;

      if (streetId && streetName && Array.isArray(house.estate)) {
        if (!acc.streets[streetId]) {
          acc.streets[streetId] = { streetName, houses: [] };
        }
        // Loop through all estates for this house
        house.estate.forEach(est => {
          if (est?.houseNumber) {
            acc.streets[streetId].houses.push({
              number: est.houseNumber,
              id: houseId
            });
          }
        });
      }

      return acc;
    }, { streets: {} });

    setStreetsData(transformedData);
    setLoadingStreets(false);
  } catch (error) {
    errorNotifier(error.response?.data?.result?.message || "Failed to load street data.");
    console.error("Error fetching streets data:", error);
    setLoadingStreets(false);
  }
};

// export const getAllTenants = async (
//   userId,
//   setLoading,
//   // setAllResidentRows,
//   setTenants
// ) => {
//   try {
//     const {
//       data: {
//         result: { data },
//       },
//     } = await http.get(AUTH_ROUTES.GET_TENANTS({ userId }));
//     setLoading(false);
//     // setAllResidentRows(data?.tenants);
//     setTenants(data?.tenants)
//   } catch (e) {
//     setLoading(false);
//     // setAllResidentRows([]);
//     // errorNotifier(e.response?.data?.result?.message);
//   } finally {
//     setLoading(false);
//   }
// };
